<script lang="ts">
    export let message: string = "Hello World!";
</script>

<div class="message">
    <!--<img src="" style="width: 16px; height: 16px"/>-->
    {message}
</div>

<style>
    .message {
        display: inline-block;
        color: var(--automapa-red);
        border: 1px solid var(--automapa-red);
        border-radius: 4px;
        padding: 2px 5px 2px 25px;
        line-height: 16px;
        background: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMTYiIHdpZHRoPSIxOCIgdmlld0JveD0iMCAwIDU3NiA1MTIiPjwhLS0hRm9udCBBd2Vzb21lIEZyZWUgNi41LjEgYnkgQGZvbnRhd2Vzb21lIC0gaHR0cHM6Ly9mb250YXdlc29tZS5jb20gTGljZW5zZSAtIGh0dHBzOi8vZm9udGF3ZXNvbWUuY29tL2xpY2Vuc2UvZnJlZSBDb3B5cmlnaHQgMjAyNCBGb250aWNvbnMsIEluYy4tLT48cGF0aCBkPSJNNTY5LjUgNDQwQzU4OCA0NzIgNTY0LjggNTEyIDUyNy45IDUxMkg0OC4xYy0zNi45IDAtNjAtNDAuMS00MS42LTcyTDI0Ni40IDI0YzE4LjUtMzIgNjQuNy0zMiA4My4yIDBsMjM5LjkgNDE2ek0yODggMzU0Yy0yNS40IDAtNDYgMjAuNi00NiA0NnMyMC42IDQ2IDQ2IDQ2IDQ2LTIwLjYgNDYtNDYtMjAuNi00Ni00Ni00NnptLTQzLjctMTY1LjNsNy40IDEzNmMuMyA2LjQgNS42IDExLjMgMTIgMTEuM2g0OC41YzYuNCAwIDExLjYtNSAxMi0xMS4zbDcuNC0xMzZjLjQtNi45LTUuMS0xMi43LTEyLTEyLjdoLTYzLjRjLTYuOSAwLTEyLjQgNS44LTEyIDEyLjd6IiBmaWxsPSIjY2IwOTM2Ii8+PC9zdmc+') 5px 50% no-repeat;
        background-size: 16px 16px;
    }
</style>